// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Kf","categoryName":"Lf","categoryImage":"Mf","categoryContent":"Nf","bottomAligned":"Of"};